import React, { useEffect } from 'react';

import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
export const FieldChangeSummaryHelp = () => {
  var fieldChangeJsonArr = [
    {
      fieldName: 'Customer Submission Group',
      description: 'Identifies the Submission Group being viewed.',
    },

    {
      fieldName: 'Processing Date',
      description: 'Date the transaction set was processed.',
    },
    {
      fieldName: 'Processing Status',
    },

    {
      fieldName: 'Field Type',
      description:
        'The Field Type column will display the type of field, including Demographic, Mailing Address, Permanent Address, Basic Life Coverage, Dental Coverage, Executive Medical Coverage, Medical Coverage, Prescription Drug Coverage, Stand Alone Coverage, Vision Coverage, Provider and Medicaid.',
    },
    {
      fieldName: 'Data Field',
      description: 'Identifies the field being changed.',
    },
    {
      fieldName: 'Successful Count',
      description:
        'The Successful Count column will contain transactions that have no errors or have warnings (severity 4 and 5 pends).  For transaction sets that exceed thresholds, this count will include transactions that have a status of Ready or Ready with Warnings.',
    },
    {
      fieldName: 'Error Count',
      description:
        'The Error Count column will contain transactions that have severity 1, 2, or 3 errors.',
    },
  ];

  var procStatusJsonArr = [
    {
      statusCode: 'COMPLETE',
      explantion:
        'Transaction set has been processed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'COMPLETED WITH WARNINGS',
      explantion:
        'Transaction set has been processed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System; however, those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'COMPLETED WITH ERRORS',
      explantion:
        'Transaction set has been processed, but with errors detected on some records.  Those records not in error have been updated to the eligibility system, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'CMPL REPR ALL',
      explantion:
        'Transaction set has been reprocessed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'CMPL REPR ALL WITH WRN',
      explantion:
        'Transaction set has been reprocessed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System; however those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'CMPL REPR ALL WITH ERR',
      explantion:
        'Tranaction set has been reprocessed, but with errors detected on some records.  Those records not in error have been updated to the Electronic Eligibility Management System, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'CMPL REPR PART',
      explantion:
        'Some transactions within this transaction set have been reprocessed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'CMPL REPR PART WITH WRN',
      explantion:
        'Some transactions within this transaction set have been reprocessed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System; however those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'REPR THRESH XCD',
      explantion:
        'Thresholds violations were encountered during re-processing.  Entire transaction set is in error on the Electronic Eligibility Management System until researched and corrected by the Electronic Eligibility Analyst assigned to the submission group.',
    },
  ];

  return (
    <>
      <p>
        The Field Change Summary screen displays a summary of changes for a file
        run by field name. This page includes a list of all fields that are
        processed by Electronic Eligibility Management System along with the
        count of transactions that had a change to that particular field. The
        data field name will have a link to a page that will display all the
        transactions having a change to that field.
      </p>
      <Table.Container title="Manual Static Table">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column>Field Name</Table.Column>
            <Table.Column>Description</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        {fieldChangeJsonArr.map((item) => (
          <Table.TableBody>
            {!(item.fieldName == 'Processing Status') && (
              <Table.Row>
                <Table.Cell>{item.fieldName}</Table.Cell>
                <Table.Cell>{item.description}</Table.Cell>
              </Table.Row>
            )}
            {item.fieldName === 'Processing Status' && (
              <Table.Row>
                <Table.Cell>Processing Status</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Status Code</Table.Column>
                        <Table.Column>Explanation</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {procStatusJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.statusCode}</Table.Cell>
                          <Table.Cell>{item2.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.TableBody>
        ))}
      </Table.Container>
    </>
  );
};
